/**
 * Authors: mariushirjanu
 * Created: 04/08/2021
 */
import { util } from '../../shared/util';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormattingService } from '../../shared/services/formatting.service';
import { CompanyProfileDataService } from './company-profiles-data.service';
import { STATE_COMPANYPROFILES_INVOICEDETAIL, STATE_COMPANYPROFILES_INVOICEOVERVIEW } from '../../shared/app-states';
import { GaWizard } from '../../shared/wizard/ga-wizard';
import { GaWizardService } from '../../shared/wizard/ga-wizard.service';
import { WIZARD_COMPANY_PROFILES } from '../../shared/app-wizards';

@Component({
  selector: 'company-profiles',
  template: `
    <wizard-wrapper [wizardTitle]="title" [error]="error" [loading]="loading" [wizardId]="wizardId">
    </wizard-wrapper>
  `
})
export class CompanyProfilesComponent implements OnInit, OnDestroy {
  @Input() public companyCountryId:number;

  private wizard:GaWizard;
  public title:string;
  public error:string;
  public loading:string;
  public wizardId:string = WIZARD_COMPANY_PROFILES;

  constructor(
    private formattingService:FormattingService,
    private companyProfileDataService:CompanyProfileDataService,
    private wizardService:GaWizardService
  ) {
    this.wizard = wizardService.getInstance(this.wizardId);
  }

  public ngOnInit():void {
    if (util.isNaNOrNullOrUndefined(this.companyCountryId)) {
      this.error = 'Company Country ID missing or not a number';
      return;
    }

    this.loading = 'Loading ...';
    this.companyProfileDataService.loadCompanyCountry(this.companyCountryId)
      .then(companyCountry => {
        this.title = this.formattingService.formatCompanyCountryL(companyCountry);
        this.initWizard();
      })
      .finally(() => {
        this.loading = undefined;
      });
  }

  private initWizard() {
    this.wizard.steps([
      this.wizardService.createStep('invoice', 'Invoice Templates', undefined, STATE_COMPANYPROFILES_INVOICEOVERVIEW, undefined, [ STATE_COMPANYPROFILES_INVOICEDETAIL ], true)
    ]);
    this.wizard.sync();
  }

  public ngOnDestroy():void {
    this.wizard.clear();
  }
}